// extracted by mini-css-extract-plugin
module.exports = {"container":"e_4h","icon":"e_5h","pathBg":"e_6h","pathFg":"e_7h","variantViolet":"e_8h","variantBase":"e_9h"};